import { useEffect, useState, useCallback } from "react";

type Theme = "dark" | "light" | "system";
const KEY = "eduerp.theme";

function applyTheme(theme: Theme) {
    const root = document.documentElement;
    const resolved =
        theme === "system"
            ? window.matchMedia("(prefers-color-scheme: light)").matches
                ? "light"
                : "dark"
            : theme;
    root.classList.remove("dark", "light");
    root.classList.add(resolved);
}

export function useTheme() {
    const [theme, setThemeState] = useState<Theme>(() => {
        const stored = localStorage.getItem(KEY) as Theme | null;
        return stored ?? "dark";
    });

    useEffect(() => {
        applyTheme(theme);
        localStorage.setItem(KEY, theme);
    }, [theme]);

    useEffect(() => {
        if (theme !== "system") return;
        const mq = window.matchMedia("(prefers-color-scheme: light)");
        const handler = () => applyTheme("system");
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, [theme]);

    const setTheme = useCallback((t: Theme) => setThemeState(t), []);
    return { theme, setTheme };
}
